import { FC } from 'react';
import CardImage2 from './CardImage2';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTranslatedCard } from '../../hooks/useCards';

interface CardDialogProps {
    open: boolean;
    onClose: () => void;
    card: {
        id: number;
        card_name?: string;
        primary_meaning?: string;
        interpretation?: string;
        reversed: boolean;
    };
}

const CardDialog: FC<CardDialogProps> = ({ open, onClose, card }) => {
    const { t } = useTranslation();
    const translatedCard = useTranslatedCard(card?.id);
    console.log("translatedCard", translatedCard);

    const handleOpen = React.useCallback(() => {
        // This is intentionally empty as we're controlling the open state from the parent
    }, []);

    // Use translated card information if available, otherwise fall back to the provided card data
    const cardName = translatedCard?.card_name || card?.card_name || `Card ${card?.id}`;
    const primaryMeaning = translatedCard?.description?.primary_meaning || card?.primary_meaning || '';
    const interpretation = translatedCard?.description?.interpretation || card?.interpretation || '';

    return (
        <div className="relative pt-0">
            {/* Drawer handle indicator */}
            <div className="flex justify-center mb-4">
                <div className="w-24 h-1 bg-gray-500 rounded-full opacity-80"></div>
            </div>

            <h2 className="text-2xl font-bold mb-4">

                {card?.reversed ? `${cardName} ${t('cardDialog.reversed')} ` : cardName}
            </h2>
            <div className="flex flex-col md:flex-row gap-6">
                <div className="md:w-2/3">
                    <h3 className="text-xl font-semibold mb-2">{t('cardDialog.primaryMeaning')}</h3>
                    <p className="mb-4">{primaryMeaning}</p>
                </div>
                <div className="md:w-1/3 text-center flex justify-center items-center">
                    <CardImage2 visible={true} id={card?.id} width={200} reversed={card?.reversed} />
                </div>
                <div className="md:w-2/3">
                    <h3 className="text-xl font-semibold mb-2">{t('cardDialog.interpretation')}</h3>
                    <p className="mb-4 text-justify">{translatedCard?.description?.reversed || `${t('cardDialog.reversed')} `}</p>
                </div>
            </div>
        </div>
    );
};

export default CardDialog; 